import { ToolModel, ToolPreviewModel } from '@/lib/models';
import { httpSingleton } from '@/lib/http-client';

export const toolsService = {
	getTools() {
		return httpSingleton.orchestrateRequest<{ tools: ToolModel[] }>({
			method: 'GET',
			url: '/advisory-service/api/v1/tools',
		});
	},
	getTool(toolId: string) {
		return httpSingleton.orchestrateRequest<{ tool: ToolModel }>({
			method: 'GET',
			url: `/advisory-service/api/v1/tools/${toolId}`,
		});
	},
	launchTool(toolId: string) {
		return httpSingleton.orchestrateRequest<{ launchUrl: string }>({
			method: 'POST',
			url: `/advisory-service/api/v1/tools/${toolId}/launch`,
		});
	},
	getToolPreview(toolId: string, toolVersionId: string) {
		return httpSingleton.orchestrateRequest<{ tool: ToolPreviewModel }>({
			method: 'GET',
			url: `/advisory-service/api/v1/tools/${toolId}/versions/${toolVersionId}/preview`,
		});
	},
	launchToolPreview(toolId: string, toolVersionId: string) {
		return httpSingleton.orchestrateRequest<{ launchUrl: string }>({
			method: 'POST',
			url: `/advisory-service/api/v1/tools/${toolId}/versions/${toolVersionId}/preview/launch`,
		});
	},
};
